import React from "react";
import Typography from "@mui/joy/Typography";
import {Stack} from "@mui/joy";
import withNavigate from "../../utils/withNavigate";
import CommonFilterModal from "./CommonFilterModal";
import Pagination from "./Pagination";


class CommonPaginatedComponentList extends React.Component{
    render() {
        return (
            <Stack
                direction="column"
                spacing={2}
            >
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                >
                    <Typography level="h1" fontSize="xl4">
                        {this.props.title}
                    </Typography>
                    {
                        this.props.filterFields?
                            <CommonFilterModal
                                callBack={this.props.filterCallBack}
                                filterFields={this.props.filterFields}
                            />:
                            null
                    }
                </Stack>
                <Stack
                    spacing={2}
                >
                    {this.props.data.map((each) => {
                            let props = {};
                            props[`${this.props.componentKeyword}`] = each
                            return (
                                <this.props.component
                                    {...props}
                                />
                            )
                    })}
                </Stack>
                {
                    this.props.pages!==1?
                        <Pagination
                            count={this.props.pages}
                            page={this.props.pageNumber}
                            onClick={
                                (value) => {
                                    this.props.navigate(`/${this.props.url}/page/`+value);
                                }
                            }
                        />:
                        null
                }
            </Stack>
        )
    }
}

export default withNavigate(CommonPaginatedComponentList)